import { render, staticRenderFns } from "./IncomeTaxSlabComponent.vue?vue&type=template&id=b57260a6&"
import script from "./IncomeTaxSlabComponent.vue?vue&type=script&lang=js&"
export * from "./IncomeTaxSlabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports